const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const alphaOnlyRegex = /^[A-Za-z]+$/;
const alphaNumeralRegex = /[^0-9a-zA-Z]/;

export function isInputEmpty(input: string): boolean {
  return input.trim().length === 0;
}

export function isEmailValid(email: string): boolean {
  return emailRegex.test(email);
}

export function alphaOnly(input: string): boolean {
  return alphaOnlyRegex.test(input);
}

export function stringLengthCalculator(input: string): number {
  return input.trim().length;
}

export function alphaNumOnly(input: string): boolean {
  return alphaNumeralRegex.test(input);
}

export function anyNull(...values: (string | null | undefined)[]): boolean {
  return values.some((value) => value === null || value === undefined);
}
